<template>
<div
  class="application-launcher"
  @click="toggleOpen('launcher')"
>
  <i id="applicationLauncherIcon" class="fas fa-grid-2 tgb-fa-icon"/>
  <div
    v-if="open"
    class="application-launcher-dropdown"
  >
    <p class="application-launcher-dropdown-title">Apps</p>
    <template v-if="launcherApplications">
      <div
        v-for="app in launcherApplications"
        :key="app.name"
        :id="app.name"
        class="launcher-application"
        :data-test="app.dataTest"
        @click="clickLauncherApplication(app)"
      >
        <img
          :src="app.icon"
          class="launcher-application-icon"
        />
        {{ app.name }}
      </div>
    </template>
    <p class="application-launcher-dropdown-title">Discover</p>
    <template v-if="launcherDiscoverApplications">
      <div
        v-for="app in launcherDiscoverApplications"
        :key="app.name"
        :id="app.name"
        class="launcher-application"
        :data-test="app.dataTest"
        @click="clickLauncherApplication(app)"
      >
        <img
          :src="app.icon"
          class="launcher-application-icon"
        />
        {{ app.name }}
      </div>
    </template>

    <template v-if="user?.groups?.includes('staff') && launcherStaffTools">
      <p class="application-launcher-dropdown-title">Staff Tools</p>
      <div
        v-for="app in launcherStaffTools"
        :key="app.name"
        :id="app.name"
        class="launcher-application"
        :data-test="app.dataTest"
        @click="clickLauncherApplication(app)"
      >
        <img
          :src="app.icon"
          class="launcher-application-icon"
        />
        {{ app.name }}
      </div>
    </template>
  </div>
</div>
</template>

<script>
export default {
  name: 'NavBarLauncher',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
    launcherApplications: {
      type: Array,
      default: () => ([]),
      required: false,
    },
    launcherDiscoverApplications: {
      type: Array,
      default: () => ([]),
      required: false,
    },
    launcherStaffTools: {
      type: Array,
      default: () => ([]),
      required: false,
    },
    clickLauncherApplication: {
      type: Function,
      required: true,
    },
    user: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./NavbarVars";

.application-launcher {
  position: relative;
  line-height: 40px;
  margin-right: 1rem;

  &:hover {
    .application-launcher-icon{
      opacity: 1;
      color: $tgb-secondary-font;
      background-color: $tgb-primary-accent;
    }
  }

  .application-launcher-icon {
    padding: 5px;
    border-radius: 3px;
    transition: all 0.3s ease-in-out;
    width: 22px;
    vertical-align: middle;
  }

  .application-launcher-dropdown {
    position: absolute;
    left: 0;
    background-color: $white;
    text-align: center;
    border: 1px solid $tgb-border;
    border-radius: $tgb-border-radius;
    box-shadow: 3px 3px 10px $tgb-primary-font-dark;

    .application-launcher-dropdown-title {
      text-transform: uppercase;
      font-weight: bolder;
      text-align: left;
      padding: 15px 15px 0;
      line-height: 20px;
      margin: 0;
      color: $tgb-trinary-font;
      cursor: not-allowed;
      font-size: 12px;
    }

    .launcher-application {
      padding: 8px 60px 8px 15px;
      display: flex;
      font-size: 12px;
      font-weight: 500;
      white-space: nowrap;
      letter-spacing: .16em;
      color: $tgb-primary-font;
      text-transform: uppercase;
      align-items: center;

      .launcher-application-icon {
        margin-right: 10px;
        width: 35px;
        border-radius: $tgb-border-radius;
      }

      &:hover {
        background-color: $tgb-menu-hover;
      }
    }
  }
}

.dark {
  .application-launcher-dropdown {
    background-color: $tgb-navbar-dark;
    border-color: $tgb-primary-icon-hover-dark;
    box-shadow: 3px 3px 10px $tgb-navbar-dark;

    .launcher-application {
      color: $tgb-primary-font-dark;

      &:hover {
        background-color: $tgb-primary-icon-hover-dark;
      }
    }
  }
}

.dark-alt {
  .application-launcher-dropdown {
    background-color: $tgb-navbar-dark-alt;
    border-color: $tgb-primary-icon-hover-dark-alt;
    box-shadow: 3px 3px 10px $tgb-navbar-dark;

    .launcher-application {
      color: $tgb-primary-font-dark;

      &:hover {
        background-color: $tgb-primary-icon-hover-dark-alt;
      }
    }
  }
}
</style>
